import { alpha } from '@mui/material/styles';
import { COLOR_INVENTORY } from 'src/constants/colorInventory';

// ----------------------------------------------------------------------

const inventoryKeyedByHex = COLOR_INVENTORY.reduce((acc, item) => {
  const key = item.id;
  acc[key] = item.defaultValue;
  return acc;
}, {});

const resolveHex = (hex, overrides = {}) => {
  const key = `hex-${hex.replace('#', '').toLowerCase()}`;
  return overrides[key] || hex;
};

export const createPalette = (resolvedColors = {}) => {
  const overrides = { ...inventoryKeyedByHex, ...resolvedColors };
  const getColor = (hex) => resolveHex(hex, overrides);

  const GREY = {
    0: getColor('#FFFFFF'),
    100: getColor('#F9FAFB'),
    200: getColor('#F4F6F8'),
    300: getColor('#DFE3E8'),
    400: getColor('#C4CDD5'),
    500: getColor('#919EAB'),
    600: getColor('#637381'),
    700: getColor('#454F5B'),
    800: getColor('#212B36'),
    900: getColor('#161C24'),
  };

  const PRIMARY = {
    lighter: getColor('#D1E9FC'),
    light: getColor('#76B0F1'),
    main: getColor('#2065D1'),
    dark: getColor('#103996'),
    darker: getColor('#061B64'),
    contrastText: getColor('#fff'),
  };

  const SECONDARY = {
    lighter: getColor('#D6E4FF'),
    light: getColor('#84A9FF'),
    main: getColor('#3366FF'),
    dark: getColor('#1939B7'),
    darker: getColor('#091A7A'),
    contrastText: getColor('#fff'),
  };

  const INFO = {
    lighter: getColor('#D0F2FF'),
    light: getColor('#74CAFF'),
    main: getColor('#1890FF'),
    dark: getColor('#0C53B7'),
    darker: getColor('#04297A'),
    contrastText: getColor('#fff'),
  };

  const SUCCESS = {
    lighter: getColor('#E9FCD4'),
    light: getColor('#AAF27F'),
    main: getColor('#54D62C'),
    dark: getColor('#229A16'),
    darker: getColor('#08660D'),
    contrastText: GREY[800],
  };

  const WARNING = {
    lighter: getColor('#FFF7CD'),
    light: getColor('#FFE16A'),
    main: getColor('#FFC107'),
    dark: getColor('#B78103'),
    darker: getColor('#7A4F01'),
    contrastText: GREY[800],
  };

  const ERROR = {
    lighter: getColor('#FFE7D9'),
    light: getColor('#FFA48D'),
    main: getColor('#FF4842'),
    dark: getColor('#B72136'),
    darker: getColor('#7A0C2E'),
    contrastText: getColor('#fff'),
  };

  return {
    common: { black: getColor('#000'), white: getColor('#fff') },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    divider: alpha(GREY[500], 0.24),
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
    },
    background: {
      paper: getColor('#fff'),
      default: GREY[100],
      neutral: GREY[200],
    },
    action: {
      active: GREY[600],
      hover: alpha(GREY[500], 0.08),
      selected: alpha(GREY[500], 0.16),
      disabled: alpha(GREY[500], 0.8),
      disabledBackground: alpha(GREY[500], 0.24),
      focus: alpha(GREY[500], 0.24),
      hoverOpacity: 0.08,
      disabledOpacity: 0.48,
    },
    crmTheme: overrides,
  };
};

const palette = createPalette();
export default palette;
